// extracted by mini-css-extract-plugin
export default {"ClientWrapper":"ClientsList_ClientWrapper__O5puM","ClientEditWrapper":"ClientsList_ClientEditWrapper__NZ1ND","EmptyState":"ClientsList_EmptyState__YKlod"};